import React from "react";
import { useHistory } from "react-router-dom";
import { Modal, Button } from "antd";
import "./Locker.css";
import ImageModal from "../../assets/visuals/image-modale.png";
import BillingFeature from "../Billing/BillingFeature";

const ModalUpgradeLinks = ({
  subtitle,
  showUpgradeModal,
  setShowUpgradeModal,
}) => {
  const history = useHistory();
  return (
    <Modal
      visible={showUpgradeModal}
      closable={false}
      width={800}
      footer={null}
      className="upgrade-modal"
      onOk={() => {
        setShowUpgradeModal(false);
        history.push("/billing");
      }}
      onCancel={() => {
        setShowUpgradeModal(false);
      }}
    >
      <div className="modal-header-picture">
        <img src={ImageModal} width="100%" alt="modal header" />
      </div>
      <div className="modal-upgrade-content">
        <div className="header-modal">{subtitle}</div>
        <div className="upgrade-features">
          <BillingFeature
            hasFeature={true}
            detail="Accédez à tous les blocs - Vidéos, live, musique, etc..."
          />
          <BillingFeature
            hasFeature={true}
            detail="Accédez à tous les styles - Débloquez tous les thèmes et laissez parler votre créativité"
          />
          <BillingFeature
            hasFeature={true}
            detail="Accèdez aux statistiques de vos pages - Mettez en avant les liens les plus engageants"
          />
        </div>
        <Button
          className="submit-link"
          size="large"
          style={{ width: "fit-content" }}
          onClick={() => {
            setShowUpgradeModal(false);
            history.push("/billing");
          }}
        >
          Testez 7 jours gratuitement
        </Button>
      </div>
    </Modal>
  );
};

export default ModalUpgradeLinks;
